/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileImg = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M9.527 17v-4.87h1.045V17zm1.996 0v-4.87h1.092l1.548 3.208 1.527-3.209h1.092V17H15.75v-3.156l-1.286 2.687h-.643l-1.287-2.647V17zm8.36-2.07v-.563h1.802v2.392a3.815 3.815 0 0 1-1.621.335c-.822 0-1.445-.22-1.87-.657-.42-.438-.63-1.08-.63-1.93 0-.522.103-.966.309-1.333.21-.37.509-.652.897-.844.394-.196.867-.295 1.42-.295.206 0 .41.018.61.054.206.036.398.09.577.16v.885a4.096 4.096 0 0 0-.61-.147 3.1 3.1 0 0 0-.536-.047c-.514 0-.909.136-1.186.408-.272.268-.409.655-.409 1.16 0 .562.119.984.356 1.266.24.277.607.415 1.098.415.21 0 .416-.013.617-.04v-.945z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileImg as FileImg };
